import styled from 'styled-components';

export const CascaderMlStyled = styled.div`
  height: 40px;
  .ant-cascader-picker-disabled {
    background-color: transparent;
    border-bottom: 1px dotted rgb(148, 148, 148);
  }
  .cascader-wrap {
    .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled) {
      font-weight: normal;
    }
    .ant-input::placeholder {
      color: rgb(21, 101, 192);
      opacity: 0.42;
    }
    .ant-cascader-picker-label {
      color: #1565c0;
      padding-right: 30px;
      overflow: initial;
      overflow: ${(props) => (props.isDisplayRender ? 'initial' : 'hidden')};
    }
  }

  .ant-cascader-picker {
    display: flex;
    width: 100%;
    height: 100%;
    .ant-cascader-input {
      border: none;
      border-bottom: 1px dotted rgb(148, 148, 148);
      position: relative;
      left: 0;
      bottom: -10px;
    }

    &.edit {
      border-bottom: 1.5px solid rgb(148, 148, 148);
      position: relative;
      left: 0;
      bottom: -5px;
      &:hover {
        border-bottom: 3px solid rgb(21, 101, 192);
      }

      &:focus {
        box-shadow: none;
        outline: none;
        border-bottom: 2px solid rgb(21, 101, 192);
      }

      .ant-cascader-input {
        border: none;
        &:hover {
          border: none;
          box-shadow: none;
        }
        &:focus {
          box-shadow: none;
          border: none;
        }
        &:active {
          box-shadow: none;
          border: none;
        }
      }
    }
    &.disabled {
      .ant-cascader-picker-label {
        color: rgba(0, 0, 0, 0.38);
      }
    }
  }
  .antd-cascade--wrap {
    .display-render-wrap {
      position: relative;
      .display-render-tip {
        display: none;
        position: absolute;
        bottom: 27px;
        left: 0;
        padding: 6px 8px;
        background-color: #000000bf;
        border-radius: 2px;
        box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014,
          0 9px 28px 8px #0000000d;
        color: #fff;
        .display-render-tip-arrow {
          left: 22px;
          position: absolute;
          bottom: -7px;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 8px solid #000000bf;
        }
      }
    }
  }
  .antd-cascade--wrap:hover {
    .display-render-wrap {
      .display-render-tip {
        display: inline-block;
      }
    }
  }
`;
